import { ReactNode } from 'react';

export const CardContainerLayout = ({ children }: { children: ReactNode }) => {
  return (
    <div className="container max-w-screen-lg p-2 pt-4">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">{children}</div>
    </div>
  );
};
